import { FC, PropsWithChildren } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';

const Wrapper: FC<PropsWithClassName<PropsWithChildren>> = ({ className, children }) => {
  return (
    <div
      className={cn(
        'bg-white rounded-xl px-4 py-3 flex flex-col gap-4 [&>*:last-child]:pb-0 [&>*:last-child]:border-b-0',
        className
      )}
    >
      {children}
    </div>
  );
};

const Row: FC<PropsWithChildren<PropsWithClassName>> = ({ className, children }) => {
  return <div className={cn('border-primary border-b border-opacity-25 pb-4', className)}>{children}</div>;
};

export default {
  Wrapper,
  Row,
};
